module.exports = __webpack_public_path__ + "static/media/arrow-2.69fd2260.svg";